import useChatsItems from '@src/hooks/useChatsItems';
import useChatsItemsSize from '@src/hooks/useChatsItemsSize';
import { increaseOffsetChatsOnHold } from '@src/reducers/chats';
import { RefObject, useRef } from 'react';
import { useDispatch } from 'react-redux';
import ChatListItems from '../ChatListItems';
import './ChatsOngoing.css';

const ChatsOngoing: React.FC<{ chatsSearchRef: RefObject<HTMLDivElement> }> = ({
  chatsSearchRef,
}) => {
  const dispatch = useDispatch();
  const chatsOngoingRef = useRef<HTMLDivElement>(null);

  const chatsItemsSize = useChatsItemsSize(chatsOngoingRef, chatsSearchRef);
  const chatsOnHoldItems = useChatsItems();

  return (
    <div className="ChatsOngoingBox" ref={chatsOngoingRef}>
      <ChatListItems
        key="CHATS_ONGOING"
        items={chatsOnHoldItems}
        height={chatsItemsSize}
        onScrollBottom={() => dispatch(increaseOffsetChatsOnHold())}
      />
    </div>
  );
};

export default ChatsOngoing;
